<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Titel">
          <b-input maxlength="255" v-model="item.title"></b-input>
        </b-field>
      </div>
      <div class="column">
        <!--<b-field label="Bestelldatum">
          <b-input maxlength="255" v-model="item.orderdate"></b-input>
        </b-field>-->

      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Vorname">
          <b-input maxlength="255" v-model="item.firstname"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname">
          <b-input maxlength="255" v-model="item.lastname"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Email">
          <b-input maxlength="255" v-model="item.email"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Firma">
          <b-input maxlength="255" v-model="item.company"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="PLZ">
          <b-input maxlength="255" v-model="item.zipCode"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Ort">
          <b-input maxlength="255" v-model="item.city"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Strasse">
          <b-input maxlength="255" v-model="item.street"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Land">
          <b-input maxlength="255" v-model="item.country"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Spiel">
          <b-input maxlength="255" v-model="item.game"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Format">
          <b-input maxlength="255" v-model="item.format"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Umfang">
          <b-input maxlength="255" v-model="item.item"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Verpackung">
          <b-input maxlength="255" v-model="item.package"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Verpackungs-Ausstattung">
          <b-input maxlength="255" v-model="item.packEquipment"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Newsletter">
          <div class="field">
            <b-checkbox v-model="item.newsletter"
                        true-value="true"
                        false-value="false">
              {{ item.newsletter }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
    </div>


    <div class="columns">
      <div class="column">
        <b-field label="Zusatzprodukt">
          <b-input maxlength="255" v-model="item.addon"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="orderCode">
          <b-input maxlength="255" v-model="item.orderCode"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Einzelpreisauswahl">
          <div class="field">
            <b-checkbox v-model="item.singleQuantity"
                        true-value="true"
                        false-value="false">
              {{ item.singleQuantity }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Quantity1 ">
          <b-input maxlength="255" v-model="item.quantity1"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Quantity2">
          <b-input maxlength="255" v-model="item.quantity2"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Quantity3">
          <b-input maxlength="255" v-model="item.quantity3"></b-input>
        </b-field>
      </div>
    </div>



    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Exemplary">
          <b-input maxlength="255" v-model="item.exemplary"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Remark ">
          <b-input maxlength="255" v-model="item.remark"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="ZohoCode">
          <b-input maxlength="255" v-model="item.zohoCode"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Emailprocessed">
          <div class="field">
            <b-checkbox v-model="item.emailprocessed"
                        true-value="true"
                        false-value="false">
              {{ item.emailprocessed }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Zohoprocessed">
          <div class="field">
            <b-checkbox v-model="item.zohoprocessed"
                        true-value="true"
                        false-value="false">
              {{ item.zohoprocessed }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Mailchimprocessed">
          <div class="field">
            <b-checkbox v-model="item.mailchimprocessed"
                        true-value="true"
                        false-value="false">
              {{ item.mailchimprocessed }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Zoho-Error">
          <div class="field">
            <b-checkbox v-model="item.zohoerror"
                        true-value="true"
                        false-value="false">
              {{ item.zohoerror }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Mailchimp-Error">
          <div class="field">
            <b-checkbox v-model="item.mailchimperror"
                        true-value="true"
                        false-value="false">
              {{ item.mailchimperror }}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column">

      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'

const axios = require('axios');


export default {
  name: "SingleOffer",
  components: {},
  data() {
    return {
      title: "Neues Angebot anlegen",
      item: {},
      loading: true,
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {},
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Angebot bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/offers/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
    }

  },
  methods: {
    save: function () {

      //Set-Package
      var _this = this;
      var url = '/api/offers';


      console.log("SAVE");
      console.log(url);
      console.log(this.item);

      axios.put(url, this.item, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.$router.push({name: 'offers'})
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });


    }
  }
};

</script>
